import { ShirtSuggestion } from '../../types/match';

/** Játékosonként a mezszám-jelöltek, a valószínűség szerint csökkenő sorrendben. */
export type ShirtSuggestionMap = Map<number, ShirtSuggestion['candidates']>;

export const toSuggestionMap = (list: ShirtSuggestion[]): ShirtSuggestionMap =>
  new Map(list.map((s) => [s.playerId, s.candidates]));

/** Az első olyan javasolt szám, amit a meccsen még senki nem visel. */
export const suggestShirt = (
  playerId: number,
  suggestions: ShirtSuggestionMap,
  taken: Set<number>
): number | undefined => suggestions.get(playerId)?.find((c) => !taken.has(c.number))?.number;

/**
 * Ütközésmentes kitöltés: a legerősebb előzmény nyer (aki egy számot gyakrabban és
 * frissebben viselt), aki így kimarad, a következő jelöltjét kaphatja. Akinek nincs
 * szabad jelöltje, üresen marad.
 */
export const fillShirts = (
  playerIds: number[],
  suggestions: ShirtSuggestionMap,
  taken: Set<number>
): Map<number, number> => {
  const options = playerIds.flatMap((playerId) =>
    (suggestions.get(playerId) ?? []).map((c, rank) => ({ playerId, number: c.number, score: c.score, rank }))
  );
  options.sort((a, b) => a.rank - b.rank || b.score - a.score);

  const used = new Set(taken);
  const result = new Map<number, number>();
  options.forEach((o) => {
    if (result.has(o.playerId) || used.has(o.number)) return;
    result.set(o.playerId, o.number);
    used.add(o.number);
  });
  return result;
};
